import { getStores } from "../../services/MainService";
const state = {
  matchStores: [],
};
const getters = {
  allMatchStores: (state) => state.matchStores,
};
const actions = {
  async fetchMatchStores({ commit }, model ) {
    const response = await getStores(model);
    commit("setMatchStores", response);
  },
};
const mutations = {
    setMatchStores: (state, matchStores) =>
    (state.matchStores = matchStores),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
